/**
 * Validates whether a date can be added to the form's date selection list.
 * Checks for duplicates and ensures the date is not in the past.
 *
 * @param date - The date to validate (MM/DD/YYYY format)
 * @param currentFormDates - Currently selected dates (MM/DD/YYYY format)
 * @returns Updated formDates array if valid, or null if date should be ignored
 *          (either duplicate or past date)
 */
export const shouldAddDateToFormDates = (
  date: string,
  currentFormDates: string[]
): string[] | null => {
  // Check if date already exists in formDates
  if (currentFormDates.includes(date)) {
    return null // Already exists, ignore
  }

  // Parse the date (MM/DD/YYYY) and check if it's not in the past
  const [mm, dd, yyyy] = date.split('/')
  const selectedDate = new Date(Number.parseInt(yyyy), Number.parseInt(mm) - 1, Number.parseInt(dd))
  const today = new Date()
  today.setHours(0, 0, 0, 0) // Normalize to start of day

  if (selectedDate < today) {
    return null // Date is in the past, ignore
  }

  // Add date to formDates
  return [...currentFormDates, date]
}
